/**
 * Row-label widths, shared by the three charts that have a label column — `DimensionBars`,
 * `PairedBars` and `UnitMatrix` (layout round, 2 October 2026).
 *
 * SVG has no `text-overflow`, so a label too long for its column has to be cut here rather
 * than by the renderer. Every caller keeps the full text in the row's own `<title>`, so an
 * ellipsis never loses a name — it only stops one watershed from writing over the track.
 */

/** The label column, in viewBox units; the bar charts and the matrix share it. */
export const LABEL_COL_W = 118;

/**
 * Average glyph width at the label's 11.5 px. Deliberately generous (a label of mostly
 * narrow letters keeps a character or two of slack) because an over-long label overrunning
 * the track is the one failure a reader cannot read around.
 */
export const LABEL_CHAR_W = 5.6;

export const LABEL_MAX_CHARS = Math.floor(LABEL_COL_W / LABEL_CHAR_W);

/** The label as the column can hold it, with an ellipsis when it cannot hold all of it. */
export function clipLabel(label: string, maxChars = LABEL_MAX_CHARS): string {
  return label.length <= maxChars
    ? label
    : `${label.slice(0, Math.max(1, maxChars - 1)).trimEnd()}…`;
}
